module.exports = __webpack_public_path__ + "static/About_me-22a40a6e0e06f4a939303fb8457a12f2.png";